import { CustomAppLayout } from '../../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Box, Button, Container, FormField, Input, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiArrowDown } from '@mdi/js';
import Icon from '@mdi/react';
import CurrencyInput from '../../../../../../components/CurrencyInput';
import Favorites from '../../../../../../components/extras/Favorites';
import SelectUser from '../../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { ItemUser } from '../../../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setData } from '../../../../../commons/functions';



export const MembersAccountsTransferPage = () => {
    //const storeAdmin = useStoreAdmin();

    const { menu, idUser } = useGlobalState();

    const refAmmount = useRef<HTMLInputElement>(null);
    const refTarget = useRef<HTMLDivElement>(null);



    const [user, setUser] = useState<ItemUser>();
    const [obs, setObs] = useState("");
    const [idUserTarget, setIdUserTarget] = useState(0);
    const [ammount, setAmmount] = useState(0);

    const handleUser = async () => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/login/data',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({})
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code === 0) {
                setUser(dataWeb);
            }
            const data = await response.json();
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
        };
    }
    useEffect(() => {
        handleUser();
    }, []);
    const handleTransfer = async () => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/movements/transfer',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    ammount: ammount,
                    idUserSource: idUser,
                    idUserTarget: idUserTarget,
                    obs: obs,
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code === 0) {
                setIdUserTarget(0)
                setAmmount(0)
                setObs("")
            }
            const data = await response.json();
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
        };
    }
    useEffect(() => {

    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header actions={<Favorites />} variant="h1">Transferencia entre socios</Header>

                    {!!user && user.balance <= 0 && (
                        <SpaceBetween size="s">
                            <Alert type='warning' header='Saldo insuficiente' dismissible={false}
                                action={<>{formatCurrency(user.balance, "CLP") + " disponibles"}</>}
                            >
                                No tienes saldo disponible para realizar transferencias. Por favor, recarga tu cuenta para poder transferir fondos a otros socios.
                            </Alert>
                        </SpaceBetween>
                    )}
                    {!!user && user.balance > 0 && (

                        <SpaceBetween size="s">
                            <div style={{ width: 300 }}>
                                <Container
                                    header={
                                        <>Saldo máximo disponible: <strong>{formatCurrency(user.balance, "CLP")}</strong></>
                                    }
                                    footer={

                                        <SpaceBetween direction='vertical' size='xs'>
                                            <FormField label="Observaciones" constraintText={"Opcional"}>
                                                <Input value={obs} onChange={(e) => {
                                                    setObs(e.detail.value)
                                                }}
                                                />
                                            </FormField>

                                            <Box float='right'>
                                                <Button onClick={() => handleTransfer()} variant='primary' disabled={
                                                    !(ammount > 0 && idUser > 0 && idUserTarget > 0 && idUser !== idUserTarget && ammount < user.balance)
                                                }>Transferir</Button>
                                            </Box>


                                        </SpaceBetween>
                                    }>
                                    <SpaceBetween size='l' direction='vertical'>
                                        {idUser}
                                        <div style={{ width: 250, alignContent: "center" }}>
                                            <FormField label="Socio origen">
                                                <SelectUser
                                                    value={idUser}
                                                    readonly />
                                            </FormField>
                                            <Box textAlign='center'>
                                                <Icon path={mdiArrowDown} size={2} />
                                            </Box>
                                            <Box textAlign='center'>
                                                <div style={{ width: 150, margin: "0 auto", textAlign: "left" }}>
                                                    <FormField label="Monto" errorText={user.balance < ammount ? `El monto no puede superar su saldo actual de ${formatCurrency(user.balance, "CLP")}` : ""}>
                                                        <CurrencyInput value={ammount}
                                                            ref={refAmmount}
                                                            disabled={idUser === 0}
                                                            width={150} onChange={(value) => {
                                                                setAmmount(value)
                                                            }} />
                                                    </FormField>
                                                </div>
                                            </Box>
                                            <Box textAlign='center'>
                                                <Icon path={mdiArrowDown} size={2} />
                                            </Box>
                                            <FormField label="Socio destino"
                                                errorText={idUser > 0 && idUserTarget > 0 && idUser === idUserTarget ? "Usuario de origen y destino no pueden ser el mismo" : ""}>
                                                <SelectUser
                                                    ref={refTarget}
                                                    disabled={idUser === 0 || ammount === 0}
                                                    value={idUserTarget}
                                                    onConfirm={(user) => setIdUserTarget(user?.idUser || 0)} />
                                            </FormField>
                                        </div>
                                    </SpaceBetween>
                                </Container>
                            </div>

                        </SpaceBetween>
                    )}
                </SpaceBetween>
            }
        />
    );
};
